module.exports = __webpack_public_path__ + "img/04.93863a19.svg";